var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',[_c('h1',{staticClass:"main-heading"},[_vm._v(_vm._s(_vm.companyName))]),_c('folders-list',{attrs:{"folders":_vm.folders,"loading":_vm.foldersLoading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }